<!-- <button
  mat-flat-button
  [disableRipple]="true"
  [color]="color"
  [disabled]="disabled"
  class="app-split-button"
  [class.app-disabled]="disabled"
>
  <div class="flex items-center">
    <div matRipple [matRippleColor]="color" class="app-action"><ng-content></ng-content></div>

    <mat-icon
      matRipple
      [matRippleColor]="color"
      [matMenuTriggerFor]="actionsMenu"
      class="app-menu-toggle font-large"
      [inline]="true"
      >arrow_drop_down</mat-icon
    >
  </div>
</button> -->

<div class="app-split-button" [class.app-disabled]="disabled">
  <div class="flex">
    <lib-button
      weight="primary"
      class="app-action flex-grow-1"
      [disabled]="disabled"
      [type]="type"
      (click)="defaultAction.emit()"
    >
      <ng-content select="[defaultAction]"></ng-content>
    </lib-button>

    <lib-button
      weight="primary"
      [matMenuTriggerFor]="actionsMenu"
      [disabled]="disabled"
      [slim]="true"
      class="app-menu-toggle"
    >
      <lib-icon icon="arrow_drop_down" class="font-large" [inline]="true"></lib-icon>
    </lib-button>
  </div>
</div>

<mat-menu #actionsMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let actionItem of actionItems"
    (click)="action.emit(actionItem.appSplitButtonAction)"
  >
    <ng-container [ngTemplateOutlet]="actionItem.template"></ng-container>
  </button>
</mat-menu>
